<template>
  <canvas ref="canvas" height="400px" width="200px"></canvas>
</template>

<script>
import { Utility } from "@/tools/utility.js";
import twemoji from "twemoji";
export default {
  props: ["render"],
  data: () => ({
    ctx: null,
    emoticonList: [
      "😀",
      "😀",
      "🍞",
      "🛀",
      "🐔",
      "🏀",
      "🐘",
      "🐨",
      "🍓",
      "🍕",
      "💩"
    ],
    emoticons: [],
    direction: false,
    horizontalRange: 25,
    opacitySpeed: 24,
    magMin: 2,
    magMax: 2,
    height: 6
  }),
  mounted() {
    this.ctx = this.$refs.canvas.getContext("2d");
    this.canvas = this.$refs.canvas;

    // setInterval(() => {this.addEmoticon("😀")},1000)
    setInterval(() => {
      this.renderEmoticon();
    }, 1000 / 60);
  },
  methods: {
    addEmoticon(emoticon) {
      if (!this.render) return;
      let $this = this;
      let url = require("@/assets/emoticons/" +
        twemoji.convert.toCodePoint(emoticon) +
        ".png");
      let img = new Image();
      img.src = url;
      img.onload = function() {
        let center = $this.canvas.width / 2 - 16;
        let upperX = center + center / 2;
        let lowerX = center - center / 2;
        let object = {
          x: Utility.minMax(lowerX, upperX),
          y: $this.canvas.height,
          count: 0,
          img: img,
          left: $this.direction,
          magnifier: Utility.minMax($this.magMin, $this.magMax)
        };
        $this.direction = !$this.direction;
        $this.emoticons.push(object);
      };
    },
    renderEmoticon() {
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
      for (let i = 0; i < this.emoticons.length; i++) {
        let emoticon = this.emoticons[i];
        let size = 32 - emoticon.count / this.height;
        let shift;
        if (emoticon.left) {
          shift =
            Math.sin(emoticon.count / this.horizontalRange) *
            this.horizontalRange;
        } else {
          shift =
            Math.sin(emoticon.count / this.horizontalRange) *
            -this.horizontalRange;
        }
        this.ctx.save();
        this.ctx.globalAlpha = size / this.opacitySpeed;
        this.ctx.drawImage(
          emoticon.img,
          emoticon.x + shift,
          emoticon.y - emoticon.count,
          size,
          size
        );
        this.ctx.restore();
        emoticon.count += emoticon.magnifier;
        if (size <= 0) {
          this.emoticons.splice(i, 1);
        }
      }
    }
  }
};
</script>
